import moment from 'moment';

export function isToday(dateString) {
    return moment(dateString).isSame(moment(), "day");
}


// WEBPACK FOOTER //
// ./app/utils/datehelpers.js